import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { change, submit, isSubmitting } from "redux-form";
import { CREATE, GET_ONE, GET_LIST } from "react-admin";
import { isNil, prop, path, map, isEmpty, filter, head, propEq } from "ramda";
import {
  showNotification,
  Button,
  SaveButton,
  SimpleForm,
  LongTextInput,
  TextInput,
  BooleanInput,
  Filter
} from "react-admin";
import IconCancel from "@material-ui/icons/Cancel";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import dataProviderFactory from "../dataProvider";
import AttachMoney from "@material-ui/icons/AttachMoney";
import { required } from "ra-core";
import styled from "styled-components";
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  Select,
  InputLabel,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { PaymentsClients } from "./boxPaymentsClients";
import { CustomizedTables } from "../components/resumenPayments"

const StyledSelect = styled(Select)`
  width: 265px !important;
`;

const StyledInputLabel = styled(InputLabel)`
  &&& {
    font-size: 16px !important;
  }
`;

const StyledDiv = styled.div(() => ({
  flexDirection: "column",
  display: "flex",
  flexFlow: "nowrap",
  padding: "10px"
}));

const StyledDivBox = styled.div(() => ({
    alignItems: "center",
    maxWidth:"400px",
    display: 'flex',
}));

const StyledDialogTitle = styled.div(()=>({
  display: "flex",
  justifyContent: "space-between",
}))

const StyledSimpleForm = styled(SimpleForm)(({ theme }) => ({
  maxWidth: "350px !important",
}));

class CreateChargeTourButton extends Component {
  handleValueChange = (element) => {
    this.setState({ [element.target.id]: element.target.value });
  };

  handleValueChangeBool = (element) => {
    this.setState({ [element.target.id]: element.target.checked });
  };

  handleCheckResendConfirm = (event) => {
    this.setState({
      [event.target.name]: event.target.checked
    });
  };

  handleSendEmailCheckChange = event => {
    this.setState({
      [event.target.name]: event.target.checked,
    });
  };

  state = {
    tpa_link: false,
    error: false,
    showDialog: false,
    chargeTypeId: "2",
    isOnSubmit: false,
    chargeValue: Number((path(["props", "rental", "due"], this) || 0).toFixed(2)) > 0 
    ? Number((path(["props", "rental", "due"], this) || 0).toFixed(2)) - Number((path(["props", "rental", "discount"], this) || 0).toFixed(2)) 
    : Number((path(["props", "rental", "due"], this) || 0).toFixed(2)),
    remaining: Number((path(["props", "rental", "due"], this) || 0).toFixed(2)) > 0 
    ? Number((path(["props", "rental", "due"], this) || 0).toFixed(2)) - Number((path(["props", "rental", "discount"], this) || 0).toFixed(2)) 
    : Number((path(["props", "rental", "due"], this) || 0).toFixed(2)),
    chargeComments: "",
    extraCharge: prop("extraCharge", this.props),
    sendFinalConfirmation: true,
    resend: false,
    discount: Number((path(["props", "rental", "discount"], this) || 0).toFixed(2))
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleChangeItem = (element, type) => {
    this.setState({ [type]: element.target.value, tpa_link: false });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false });
  };

  deleteRentalFromListDom = () => {
    const { rental } = this.props;
    const tableRentalDom = document.getElementById("tours-due-table");
    if(tableRentalDom){
      const tbodyRentalTableDom = tableRentalDom.querySelector('tbody');
      if(tbodyRentalTableDom){
        tbodyRentalTableDom.querySelectorAll('tr').forEach((element, key) => {
          const cells = element.querySelectorAll('td');
          const cellIdRentalValue = cells[0].querySelectorAll('span')[0].textContent;     
          if(rental.id == cellIdRentalValue){
            tableRentalDom.rows[key].remove();
          }
        });
      }
    }
  };

  handleSaveClick = () => {
    const { showNotification } = this.props;
    // Validar que se tenga el monto a cargar y los comentarios
    if (!this.state.chargeValue || this.state.chargeValue <= 0) {
      if (showNotification) {
        showNotification("Debe ingresar un monto válido para cargar", "error");
      }
      return;
    }
    
    if (!this.state.chargeComments || this.state.chargeComments.trim() === "") {
      if (showNotification) {
        showNotification("Debe ingresar comentarios antes de guardar", "error");
      }
      return;
    }

    const { submit } = this.props;
    this.setState({ isOnSubmit: true }, () => {
      submit("charge-send");
    });
    
    if(this.state.remaining == this.state.chargeValue){
      this.deleteRentalFromListDom(); 
    }
  };

  handleSubmit = async () => {
    const { history, rental, onChargeSuccess, showNotification, onChargeResult } = this.props;
    console.log('=== INICIO handleSubmit ===');
    console.log('Props recibidas:');
    console.log('  onChargeResult:', onChargeResult);
    console.log('  onChargeSuccess:', onChargeSuccess);
    console.log('  showNotification:', showNotification);
    console.log('  rental:', rental);
    console.log('  state:', this.state);
    const bodyRequest = {
      id: rental.id,
      data: {
        id: this.props.rental.id,
        value: (Number(this.state.chargeValue) || 0) + (Number(this.state.discount) || 0),
        discount: this.state.discount,
        comments: this.state.chargeComments,
        tpaLink: this.state.tpa_link,
        chargeTypeId: this.state.chargeTypeId,
        extraCharge: this.state.extraCharge,
        sendFinalConfirmation: this.state.sendFinalConfirmation,
        resend: this.state.resend,
      },
    };
    
    try {
      const dataProvider = await dataProviderFactory("rest");
      let response;
      let isErrorResponse = false;
      
      let cameFromCatch = false;
      try {
        console.log('🔵 ANTES de llamar dataProvider');
        console.log('bodyRequest:', JSON.stringify(bodyRequest, null, 2));
        response = await dataProvider(CREATE, "rentals/generate_payment", bodyRequest);
        cameFromCatch = false;
        console.log('🔵 DESPUÉS de llamar dataProvider');
        console.log('=== PASO 1: Respuesta del dataProvider ===');
        console.log('response completa:', JSON.stringify(response, null, 2));
        console.log('response:', response);
        console.log('response.data:', response && response.data);
        console.log('response.data (stringify):', response && response.data ? JSON.stringify(response.data, null, 2) : 'null');
        
        // CRÍTICO: El dataProvider puede devolver la respuesta de diferentes formas:
        // 1. { data: {...} } - respuesta normal
        // 2. { data: { success: false, error: "...", details: "..." } } - error del backend
        // 3. El objeto directamente sin envolver en { data: {...} }
        
        // Verificar si response.data existe
        const responseData = response && response.data;
        
        console.log('=== PASO 2: Análisis de responseData ===');
        console.log('responseData:', responseData);
        if (responseData) {
          console.log('responseData.success:', responseData.success);
          console.log('responseData.error:', responseData.error);
          console.log('responseData.details:', responseData.details);
        }
        
        // Si response.data tiene 'error' o 'success: false', es un error
        // PERO: Si tiene 'success: true', es un éxito explícito
        if (responseData && typeof responseData === 'object') {
          if (responseData.success === true) {
            console.log('✅ ÉXITO EXPLÍCITO detectado en response.data');
            console.log('  - responseData.success:', responseData.success);
            // Asegurar que NO se marque como error
            isErrorResponse = false;
          } else if (responseData.error || responseData.success === false) {
            console.log('⚠️ ERROR DETECTADO en response.data (sin excepción)');
            console.log('  - responseData.error:', responseData.error);
            console.log('  - responseData.success:', responseData.success);
            isErrorResponse = true;
            this.handleCloseClick()
          }
        }
        
        // También verificar si response tiene error directamente (sin data)
        if (response && typeof response === 'object' && !response.data) {
          if (response.error || response.success === false) {
            console.log('⚠️ ERROR DETECTADO directamente en response (sin data)');
            console.log('  - response.error:', response.error);
            console.log('  - response.success:', response.success);
            isErrorResponse = true;
            // Envolver en estructura estándar
            response = { data: response };
            this.handleCloseClick()
          }
        }
        
      } catch (error) {
        cameFromCatch = true;
        // Si el dataProvider lanza una excepción, extraer la información del error
        console.log('=== PASO 1: EXCEPCIÓN del dataProvider ===');
        console.log('error completo:', error);
        console.log('error.body:', error && error.body);
        console.log('error.json:', error && error.json);
        console.log('error.message:', error && error.message);
        console.log('error.status:', error && error.status);
        console.log('error.response:', error && error.response);
        this.handleCloseClick()
        // Intentar extraer el body del error de diferentes ubicaciones
        let errorBody = null;
        if (error && error.body) {
          errorBody = error.body;
          console.log('✅ errorBody encontrado en error.body');
        } else if (error && error.json) {
          errorBody = error.json;
          console.log('✅ errorBody encontrado en error.json');
        } else if (error && error.response && error.response.body) {
          errorBody = error.response.body;
          console.log('✅ errorBody encontrado en error.response.body');
        }
        
        if (errorBody) {
          console.log('errorBody extraído:', JSON.stringify(errorBody, null, 2));
          response = { data: errorBody };
          isErrorResponse = true;
        } else {
          console.log('⚠️ No se encontró errorBody, creando estructura de error');
          // Si no hay body, crear una estructura de error
          response = { 
            data: { 
              success: error.success, 
              error: error.message , //|| 'Error al procesar el pago',
              details: error.details || null
            }
          };
          isErrorResponse = true;
        }
      }
      
      // Ahora procesar la respuesta (fuera del catch interno, dentro del try externo)
      console.log('=== PASO 3: PROCESAMIENTO DE RESPUESTA ===');
      console.log('response:', response);
      console.log('response.data:', response && response.data);
      console.log('response.data (stringify completo):', response && response.data ? JSON.stringify(response.data, null, 2) : 'null');
      console.log('isErrorResponse:', isErrorResponse);
      
      const responseData = response && response.data;
      
      // CRÍTICO: Verificar si responseData contiene los datos del request en lugar de la respuesta
      // Si responseData tiene id: undefined y otros campos del request (value, discount, etc.),
      // PERO NO tiene success: false ni error, es probable que el jsonServerProvider devolvió los datos del request
      const looksLikeRequestData = responseData && 
        typeof responseData === 'object' &&
        responseData.id === undefined && 
        (responseData.value !== undefined || responseData.discount !== undefined || responseData.comments !== undefined) &&
        responseData.success !== false && 
        !responseData.error;
      
      console.log('🔍 ANÁLISIS DETALLADO DE responseData:');
      console.log('  - responseData existe:', !!responseData);
      console.log('  - responseData es objeto:', responseData && typeof responseData === 'object');
      console.log('  - responseData.id:', responseData && responseData.id);
      console.log('  - responseData.id === undefined:', responseData && responseData.id === undefined);
      console.log('  - responseData.value:', responseData && responseData.value);
      console.log('  - responseData.discount:', responseData && responseData.discount);
      console.log('  - responseData.comments:', responseData && responseData.comments);
      console.log('  - responseData.success:', responseData && responseData.success);
      console.log('  - responseData.error:', responseData && responseData.error);
      console.log('looksLikeRequestData (parece datos del request):', looksLikeRequestData);
      
      if (looksLikeRequestData) {
        console.log('⚠️ responseData parece ser el request (json-server devuelve params.data en lugar de la respuesta)');
        console.log('  responseData contiene:', Object.keys(responseData || {}));
        // Solo forzar error si vinimos del catch (400/404). Si NO hubo excepción, la petición fue 200 OK = ÉXITO
        if (cameFromCatch) {
          isErrorResponse = true;
          console.log('  ✅ isErrorResponse forzado a true (cameFromCatch)');
        } else {
          isErrorResponse = false;
          console.log('  ✅ Tratando como ÉXITO: sin excepción = 200 OK, backend procesó correctamente');
        }
      }
      
      // CRÍTICO: Verificar explícitamente si la respuesta es exitosa
      // Si responseData.success === true, es un éxito explícito del backend
      // También verificar si tiene uid: 0 y result: "ok" (formato antiguo del backend)
      const isExplicitSuccess = responseData && (
        responseData.success === true || 
        (responseData.uid === 0 && responseData.result === 'ok' && !responseData.error && responseData.success !== false)
      );
      
      console.log('🔍 VERIFICACIÓN DE ÉXITO EXPLÍCITO:');
      console.log('  - responseData.success:', responseData && responseData.success);
      console.log('  - responseData.success === true:', responseData && responseData.success === true);
      console.log('  - responseData.uid:', responseData && responseData.uid);
      console.log('  - responseData.result:', responseData && responseData.result);
      console.log('  - isExplicitSuccess:', isExplicitSuccess);
      console.log('  - responseData:', responseData);
      
      // Verificar si hay error en la respuesta
      // isErrorResponse ya contempla looksLikeRequestData: si cameFromCatch=true → error, si cameFromCatch=false → éxito
      const hasError = !isExplicitSuccess && (
                       isErrorResponse || 
                       (responseData && responseData.success === false) ||
                       (responseData && responseData.error));
      
      console.log('🔍 EVALUACIÓN DE hasError:');
      console.log('hasError:', hasError);
      console.log('  - isExplicitSuccess:', isExplicitSuccess);
      console.log('  - isErrorResponse:', isErrorResponse);
      console.log('  - cameFromCatch:', cameFromCatch);
      console.log('  - responseData.success === false:', responseData && responseData.success === false);
      console.log('  - responseData.error existe:', !!(responseData && responseData.error));
      console.log('  - looksLikeRequestData:', looksLikeRequestData);
      console.log('  - RESULTADO FINAL hasError:', hasError);
      
        if (hasError) {
        // Extraer mensaje de error
        let errorMessage = responseData.error  //|| 'Error al procesar el pago';
        let errorDetails = null;
        
        console.log('=== PASO 4: EXTRACCIÓN DE MENSAJE DE ERROR ===');
        console.log('responseData:', responseData);
        console.log('looksLikeRequestData:', looksLikeRequestData);
        
        // Si parece datos del request, el error no está en responseData
        // Esto significa que el jsonServerProvider devolvió los datos del request en lugar de la respuesta del backend
        // En este caso, sabemos que hubo un error 400 (por los logs del httpClient), pero la respuesta no está disponible
        if (looksLikeRequestData && !responseData.error && responseData.success !== false) {
          console.log('⚠️ CRÍTICO: responseData parece ser el request, no la respuesta del backend');
          console.log('⚠️ El error del backend no está disponible en responseData');
          console.log('⚠️ Esto indica que la interceptación directa en rest.js no funcionó correctamente');
          console.log('⚠️ Usando mensaje de error genérico basado en el error 400 detectado');
          // Sabemos que hubo un error 400, usar un mensaje descriptivo
          // IMPORTANTE: Marcar como error para que se envíe correctamente
          //errorMessage = 'Error al procesar el pago. El servidor devolvió un error 400 (Bad Request). Por favor, verifique los logs del servidor para más detalles.';
          // Asegurar que isErrorResponse esté en true para que se procese como error
          isErrorResponse = true;
        } else if (responseData) {
          if (responseData.error) {
            const rawError = responseData.error;
            console.log('responseData.error (raw):', rawError);
            console.log('typeof responseData.error:', typeof rawError);
            
            errorMessage = typeof rawError === 'string' 
              ? rawError 
              : (rawError.message || String(rawError));
            
            console.log('errorMessage extraído:', errorMessage);
          } else if (responseData.success === false) {
            console.log('⚠️ responseData.success === false pero no hay error específico');
            //errorMessage = 'Error al procesar el pago';
          } else {
            console.log('⚠️ No se encontró responseData.error ni responseData.success === false');
          }
          
          if (responseData.details) {
            errorDetails = responseData.details;
            console.log('errorDetails extraído:', errorDetails);
          }
        } else {
          console.log('⚠️ responseData es null o undefined');
        }
        
        // Fallback si el mensaje de error está vacío
        const finalErrorMessage = (errorMessage && String(errorMessage).trim()) 
          ? errorMessage 
          : 'Error al procesar el pago';
        
        console.log('=== PASO 5: MENSAJE FINAL DE ERROR ===');
        console.log('errorMessage final:', finalErrorMessage);
        console.log('errorDetails final:', errorDetails);
        
        // Resetear estado de envío
        this.setState({ isOnSubmit: false });
        
        // Notificar error al componente padre
        console.log('=== PASO 6: ENVIANDO ERROR AL COMPONENTE PADRE ===');
        console.log('onChargeResult disponible:', !!(onChargeResult && typeof onChargeResult === 'function'));
        console.log('errorMessage a enviar:', errorMessage);
        
        if (onChargeResult && typeof onChargeResult === 'function') {
          const errorResult = { 
            success: false, 
            error: finalErrorMessage,
            details: errorDetails
          };
          console.log('🔴 Llamando onChargeResult con error:', errorResult);
          try {
            onChargeResult(errorResult);
            console.log('✅ onChargeResult llamado exitosamente con error');
          } catch (error) {
            console.error('❌ Error al llamar onChargeResult:', error);
            // Fallback: mostrar notificación directamente
            if (showNotification && typeof showNotification === 'function') {
              showNotification(finalErrorMessage, "error");
            } else {
              alert(`Error: ${finalErrorMessage}`);
            }
          }
        } else {
          console.log('⚠️ onChargeResult no disponible, usando showNotification directamente');
          if (showNotification && typeof showNotification === 'function') {
            showNotification(finalErrorMessage, "error");
          } else {
            alert(`Error: ${finalErrorMessage}`);
          }
        }
        return; // Salir temprano si hay error
      }
      
      // Si llegamos aquí, la operación fue exitosa
      console.log('✅ Operación exitosa');
      
      // Resetear estado
      this.setState({
        tpa_link: false,
        extraCharge: true,
        showDialog: false,
        chargeValue: 0,
        discount: 0,
        chargeTypeId: 2,
        isOnSubmit: false,
        chargeComments: "",
      });
      
      // Recargar la lista principal después de guardar el cargo
      if (this.state.remaining == this.state.chargeValue) {
        this.deleteRentalFromListDom();
      }
      
      // Notificar éxito al componente padre
      console.log('=== PASO 7: NOTIFICANDO ÉXITO ===');
      console.log('onChargeResult disponible:', !!(onChargeResult && typeof onChargeResult === 'function'));
      console.log('onChargeSuccess disponible:', !!(onChargeSuccess && typeof onChargeSuccess === 'function'));
      
      if (onChargeResult && typeof onChargeResult === 'function') {
        console.log('🔵 Llamando onChargeResult con éxito:', { success: true, data: response });
        try {
          onChargeResult({ success: true, data: response });
          console.log('✅ onChargeResult llamado exitosamente');
        } catch (error) {
          console.error('❌ Error al llamar onChargeResult:', error);
        }
      } else {
        console.log('⚠️ onChargeResult no disponible, usando fallback');
        if (showNotification && typeof showNotification === 'function') {
          showNotification("Charge created with success", "info");
        }
        if (onChargeSuccess && typeof onChargeSuccess === 'function') {
          onChargeSuccess();
        }
      }
      
      if (!isNil(history) && history.history) {
        history.history.replace(
          `/${
            rental.type === 1 ? "tour_due_list" : "rentals_due"
          }`
        );
      }
      
    } catch (error) {
      // Resetear estado de envío
      this.setState({ isOnSubmit: false });
      
      // Extraer mensaje de error de forma más robusta
      let errorMessage = error  //|| 'Error al procesar el pago';
      let errorDetails = null;
     
      
      // Notificar error al componente padre si existe el callback
      if (onChargeResult && typeof onChargeResult === 'function') {
        onChargeResult({ 
          success: false, 
          error: errorMessage,
          details: errorDetails || error.stack
        });
      } else {
        // Fallback: usar showNotification directamente si no hay callback
        if (showNotification && typeof showNotification === 'function') {
          showNotification(errorMessage, "error");
        } else {
          // Último fallback: usar alert
          //alert(`Error: ${errorMessage}`);
        }
      }
    }
  };

  getStripeType(rental) {
    const tourId = path(["booking", "tour_id", rental]);

    if ((!isNil(tourId) && tourId > 0) || !isNil(prop("type", rental))) {
      if (!isNil(prop("booking", rental))) {
        if (!isNil(rental.booking) && rental.type === 1) {
          return rental.booking.p4m ? "p4m" : "tours";
        }
        if (!isNil(rental.booking) && rental.type === 2) {
          return rental.location_id_1 === "3" ? "rentals_pt" : "rentals";
        }
      } else {
        if (rental.type === 1 && rental.p4m === 1) {
          return "p4m";
        }
        if (rental.type === 1 && rental.p4m === 0) {
          return "tours";
        }
        if (rental.type === 2 && rental.location_name_1 === "lisbon") {
          return "rentals_pt";
        }
        if (rental.type === 2 && rental.location_name_1 !== "lisbon") {
          return "rentals";
        }
      }
    }
  }

  isUserStripe = () => {
    const { rental } = this.props;
    let stripToUse = null;
    if (!isNil(rental)) {
      const stripeType = this.getStripeType(rental);
      if (stripeType !== "p4m") {
        if (!isNil(prop("driver", rental))) {
          stripToUse = prop(`stripe_${stripeType}`, rental.driver);
        } else {
          stripToUse = prop(`stripe_${stripeType}`, rental);
        }
      }
    }
    return !isNil(stripToUse);
  };

  async getRecord() {
    const id = this.props.rental.id;
    const dataProvider = await dataProviderFactory("rest");
    const response = await dataProvider(GET_ONE, "tour_clients", {
      id: id,
    });
    const record = response.data;
    if (!record) {
      this.setState({ price: null, clientData: null, clientEmail: null });
      return;
    }
    this.state.record = record;
    const booking = record.booking || record.booking_info;
    const price = await this.getTourPrice(record);
    this.setState({
      price,
      clientData: record.clientData,
      clientEmail: (booking && booking.r_email) || null,
    });
  }

  async getTourPrice(tour) {
    const booking = tour && (tour.booking || tour.booking_info);
    if (!booking) {
      return {
        tourTotal: 0,
        passengerPrice: 0,
        singlePrice: 0,
        prices: { data: [] },
        models: { data: [] },
      };
    }
    const priceDate = booking.price_date;
    const tour_id = booking.tour_id;
    if (priceDate == null || tour_id == null) {
      return {
        tourTotal: 0,
        passengerPrice: 0,
        singlePrice: 0,
        prices: { data: [] },
        models: { data: [] },
      };
    }
    const dataProvider = await dataProviderFactory("rest");

    const vehicleModels = await dataProvider(GET_LIST, "vehicle_models", {
      filter: { active: true, type: "2_2" },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "order", order: "ASC" }
    });

    const responseTourPrices = await dataProvider(GET_LIST, "prices", {
      filter: {
        for_date: priceDate,
        for_tour_id: tour_id,
      },
      pagination: {
        page: 1,
        perPage: 99999,
      },
      sort: {}
    });
    let passengerPrice = 0;
    let singlePrice = 0;

    console.log( "vehicleModels", vehicleModels)
    console.log( "tour record", tour)
    const vehicleModelId =
      booking.vehicle_model_1 != null && booking.vehicle_model_1 !== ""
        ? Number(booking.vehicle_model_1)
        : tour.vehicle_model_1 != null && tour.vehicle_model_1 !== ""
          ? Number(tour.vehicle_model_1)
          : tour.vehicle_model_id != null && tour.vehicle_model_id !== ""
            ? Number(tour.vehicle_model_id)
            : NaN
    var tourTotal = 0
    if (vehicleModelId === 2) {
      tourTotal =
        (prop(
          "price",
          head(
            filter(
              propEq("price_item_sub_type", "tour_passenger"),
              responseTourPrices.data
            )
          )
        ) || 0) + 500
    } else {
      tourTotal =
        prop(
          "price",
          head(
            filter(
              propEq("price_item_sub_type", "tour_total"),
              responseTourPrices.data
            )
          )
        ) || 0
    }

    if (!isNil(booking.p_first_name) && !isEmpty(booking.p_last_name)) {
      passengerPrice = prop(
        "price",
        head(
          filter(propEq("price_item_sub_type", "tour_passenger"), responseTourPrices.data)
        )
      ) || 0;
    }
    if (tour.r_single || booking.r_single) {
      singlePrice = prop(
        "price",
        head(
          filter(propEq("price_item_sub_type", "tour_single"), responseTourPrices.data)
        )
      ) || 0;
    }
    console.log( "tourTotal", tourTotal)

    return {
      tourTotal,
      passengerPrice,
      singlePrice,
      prices: responseTourPrices,
      models: vehicleModels,
      vehicleModelId: tour.vehicle_model_id,
    }
  }

  async componentDidMount() { 
    let path = window.location.pathname;
    if (this.props.history) {
      if (this.props.history.basePath) {
        path = this.props.history.basePath;
      } else if (this.props.history.location && this.props.history.location.pathname) {
        path = this.props.history.location.pathname;
      }
    }
    this.setState({ path: path });
    if (path == "/tour_due_list") {
      this.getRecord();
    }
   
  }

  render() {
    const chargeTypes = [
      { _id: "1", description: "Stripe" },
      { _id: "2", description: "Other (Money, bank transfer)" },
    ];

    const { rental } = this.props;
     console.log(this.state.record)
     console.log(this.state.price)
    // let haveStripe = this.isUserStripe();

    const { showDialog, isOnSubmit } = this.state;

    //console.log(rental)

    const chargeValue = rental.due

    return (
      <Fragment>
        <Button label="Charge" onClick={this.handleClick}>
          <AttachMoney titleAccess="Charge" cursor="pointer" />
        </Button>
        <Dialog
          //fullWidth={true}
          maxWidth={"lg"}
          open={showDialog}
          onClose={this.handleCloseClick}
          aria-label="Charge"
          style={{ width: '1000px !important' }}
        ><StyledDiv style={{ display: this.state.path !== "/tour_due_list" ? 'flow' : 'flex', padding: '5px !important' }}>
          <div style={{ maxWidth: "800px"}}>
            <DialogTitle>
              <StyledDialogTitle>
                <div > {/* style={{ maxWidth: "350px"}}*/}
                  { this.state.path == "/tour_due_list" ? "": `Charge - ` }
                  { `${
                    !isNil(rental.client_name)
                      ? rental.client_name
                      : `${prop("r_first_name", prop("booking", rental))} ${prop(
                          "r_last_name",
                          prop("booking", rental)
                        )} `
                  } for ${
                    rental.type === 1
                      ? `${
                          rental.tour_name
                            ? rental.tour_name
                            : path(["booking", "tour", "tour_name", "tour_name_en"], this.props.rental) || "Tour"
                        }`
                      : "Rental"
                  }`}{" "}
                  <br /> 
                  <h5>{`Start Date ${rental.date_1} to ${rental.date_2}`}</h5>                
                </div>               
              </StyledDialogTitle>
            </DialogTitle>
            <DialogContent style={{ display: "flex", flexFlow: "column" }}>
              <StyledSimpleForm
                form="charge-send"
                resource="charges"
                onSubmit={this.handleSubmit}
                toolbar={null}
                destroyOnUnmount={true}
                style={{ width: this.state.path !== "/tour_due_list" ? '100%' : '450px' }}
              >
                <StyledInputLabel htmlFor="charge-simple">
                  Charge Type *
                </StyledInputLabel>
                <StyledSelect
                  onChange={(e) => this.handleChangeItem(e, "chargeTypeId")}
                  inputProps={{
                    name: "charge",
                    id: "charge-simple",
                  }}
                  // disabled={
                  //   rental.old_system || !haveStripe || rental.from_agency
                  // }
                  disabled={true}
                  optionValue="_id"
                  validate={required()}
                  value={this.state.chargeTypeId}
                >
                  {map((item) => {
                    return (
                      <MenuItem key={item._id} value={item._id}>
                        {item.description}
                      </MenuItem>
                    );
                  }, chargeTypes)}
                </StyledSelect>

                <TextInput
                  source="chargeValue"
                  label="Charge Value (Euros)" 
                  type="number"
                  defaultValue={chargeValue}
                  onChange={this.handleValueChange}
                  validate={required()}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                {this.state.discount > 0 && ( 
                  <h5>{`Discount applied ${this.state.discount} `}</h5>)
                }
                {/* comenrtario poara registrar en imt no factura  */}
                <LongTextInput
                  source="chargeComments"
                  label="Imt Comments"
                  type="text"
                  onChange={this.handleValueChange}
                  validate={required()}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                {this.state.chargeTypeId === "1" && (
                  <BooleanInput
                    label="Pay through link"
                    source="tpa_link"
                    onChange={this.handleValueChangeBool}
                  />
                )}

                {rental.type === 1 && (
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="sendFinalConfirmation"
                        checked={this.state.sendFinalConfirmation}
                        onChange={(e) => this.handleSendEmailCheckChange(e)}
                        value="sendFinalConfirmation"
                      />
                    }
                    label="Send final confirmation e-mail"
                  />
                )}
              </StyledSimpleForm>
              <div style={{ marginTop: '1rem', padding: "0px 1rem"}}>
                { this.state.path == "/tour_due_list" ? 
                  <React.Fragment>
                    <div>{`Bank information `}<br></br>{this.state.clientData}</div>
                    <div>{`Rider Email `} <br></br>{this.state.clientEmail} </div>
                  </React.Fragment>
                  : ""
                } 
              </div> 
            </DialogContent>   
            <DialogActions>
              <SaveButton
                saving={isOnSubmit}
                onClick={this.handleSaveClick}
                disabled={
                  isOnSubmit ||
                  this.state.chargeTypeId === "" ||
                  !this.state.chargeComments ||
                  this.state.chargeComments.trim() === "" ||
                  !this.state.chargeValue ||
                  this.state.chargeValue <= 0
                }
              />
              <Button label="ra.action.cancel" onClick={this.handleCloseClick}>
                <IconCancel />
              </Button>
            </DialogActions>
          </div>
          { this.state.path == "/tour_due_list" ?
            <StyledDivBox>
              {this.state.price !== "" ?  <PaymentsClients data={this.state.record} price={this.state.price} isOpen={true}/> : <CircularProgress />}           
            </StyledDivBox>  
            : ""
          }
          { this.state.path == "/tour_due_list" ? 
            <React.Fragment>
              <StyledDivBox>
                {this.state.price !== "" ?  <CustomizedTables data={this.state.record} prices={this.state.price}/> : <CircularProgress />}                   
              </StyledDivBox>
            </React.Fragment>
            : ""
          }              
        </StyledDiv>
        </Dialog>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isSubmitting: isSubmitting("charge-send")(state),
});

const mapDispatchToProps = {
  change,
  showNotification,
  submit,
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateChargeTourButton);



// WEBPACK FOOTER //
// ./src/components/createChargeTour.js